import * as React from "react";
import { z } from "zod";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import { DynamicForm } from "../../util/DynamicForm";
import API_URL from "../../config/apiConfig";
import MutationHandler from "../../util/MutationHandler";
import { apiGet } from "../../util/axiosUtil";

export default function ResetPassword({ onCancel, onSuccess }) {
  const formConfig = {
    oldPassword: {
      label: "Old Password",
      type: "text",
      placeholder: "Old Password",
      defaultValue: "",
      required: true,
      normalize: (val) => val.replace(/\s+/g, ""),
      validation: z.string().min(0, "Please provide old password"),
    },
    newPassword: {
      label: "New Password",
      type: "text",
      placeholder: "New Password",
      defaultValue: "",
      required: true,
      normalize: (val) => val.replace(/\s+/g, ""),
      validation: z.string().min(0, "Please provide new password"),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) =>
        apiGet(
          `${API_URL}/api/users/reset-password/${formData.oldPassword}/${formData.newPassword}`
        )
      }
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <ReetPasswordForm
          formConfig={formConfig}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
          buttonText={"Reset Password"}
        />
      )}
    </MutationHandler>
  );
}

function ReetPasswordForm({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Reset Password"}
    />
  );
}
